import Conversion from './conversion'

export default class extends Conversion {
  async install () {
    await this.injectScript('p471j9l3vv')
  }

  async setup () {
    this.t('consent', true)
  }

  async injectScript (projectId) {
    try {
      /* eslint-disable */
      (function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", projectId);
      return
    } catch (e) {
      return
    }
    /* eslint-enable */
  }

  deliver ({ event: eventName }) {
    if (this.constructor.isUpgradeEvent({ eventName })) {
      this.t('upgrade', eventName)
    }

    this.t('event', eventName)
    this.t('set', 'custom_event', eventName)
    console.debug(eventName)
  }

  get t () {
    return globalThis.clarity
  }

  get installed () {
    return !!this.t
  }

  set installed (_) {
    // void
  }

  static isUpgradeEvent ({ eventName }) {
    switch (eventName) {
      case 'purchase':
        return true
      case 'begin_checkout':
        return true
      case 'add_to_cart':
        return true
      case 'newsletter_signup':
        return true
      default:
        return false
    }
  }
}
